// ── Welle A3: einen Beitrag lesen (eine Ebene tief, mit Zurück) ──
// Kopf: Serie, Position, Dauer, Titel. Unten fest „Gelesen“ (am Handy statt des schwebenden
// Mikro-Knopfs); bei Serien danach „Nächste Lektion am …“. Quelle und Stand klein am Ende.
// Die Redaktion nutzt dieselbe Ansicht als „Vorschau als Lehrkraft“ (ohne Lese-Status).
import React, { useState } from 'react';
import { MIcon } from '../../lib/micon';
import { useOhneMikroKnopf } from '../../lib/hooks';
import { Bausteine } from './Bausteine';
import { VORLAGE_ICON, VORLAGE_LABEL, datumKurz } from './typen';
import type { Aktion, BeitragVoll } from './typen';

export function BeitragLesen({ b, onZurueck, onGelesen, onAktion, bildPfad, vorschau = false, zurueckLabel = 'Sicherheit & Tipps' }: {
  b: BeitragVoll; onZurueck: () => void; onGelesen?: () => Promise<void>; onAktion?: (a: Aktion) => void;
  bildPfad: (id: number) => string; vorschau?: boolean; zurueckLabel?: string;
}) {
  useOhneMikroKnopf(!vorschau);
  const [laeuft, setLaeuft] = useState(false);
  const ernstfall = b.vorlage === 'ernstfall';
  const meta = [
    b.serie ? `${b.serie.titel}${b.position ? `, Lektion ${b.position} von ${b.serie.gesamt}` : ''}` : VORLAGE_LABEL[b.vorlage],
    b.dauer_min ? `${b.dauer_min} ${b.dauer_min === 1 ? 'Minute' : 'Minuten'}` : null,
  ].filter(Boolean).join(', ');
  const naechste = b.serie?.naechste;
  async function gelesen() {
    if (!onGelesen || laeuft) return;
    setLaeuft(true);
    try { await onGelesen(); } finally { setLaeuft(false); }
  }
  return (
    <article className={`ld-si-lesen${ernstfall ? ' ist-ernstfall' : ''}`} aria-label={b.titel}>
      <button type="button" className="ld-si-zurueck" onClick={onZurueck}><MIcon name="chevron_left" size={20} />{zurueckLabel}</button>
      {ernstfall ? (
        <header className="ld-si-lesen__kopf ist-ernstfall">
          <span className="ld-si-ernst-icon" aria-hidden="true"><MIcon name="lock_open" size={24} /></span>
          <div><h1>{b.titel}</h1>{b.teaser && <p>{b.teaser}</p>}</div>
        </header>
      ) : (
        <header className="ld-si-lesen__kopf">
          <small><MIcon name={VORLAGE_ICON[b.vorlage]} size={15} />{meta}</small>
          <h1>{b.titel}</h1>
        </header>
      )}
      <Bausteine bausteine={b.bausteine} bildPfad={bildPfad} onAktion={vorschau ? undefined : onAktion} ernstfall={ernstfall} />
      {(b.quelle || b.stand) && (
        <p className="ld-si-quelle">{[b.stand && `Stand ${b.stand}`, b.quelle && `Grundlage ${b.quelle}`].filter(Boolean).join(', ')}</p>
      )}
      {!vorschau && (
        <div className="ld-si-leiste">
          {b.gelesen ? (
            <div className="ld-si-leiste__fertig" role="status">
              <MIcon name="check_circle" size={20} fill />
              <span>Gelesen{naechste ? <>. Nächste Lektion am {datumKurz(naechste.datum)}</> : ''}</span>
            </div>
          ) : (
            <button type="button" className="ld-si-gelesen" onClick={gelesen} disabled={laeuft}><MIcon name="check" size={20} />Gelesen</button>
          )}
        </div>
      )}
    </article>
  );
}
